import { appActionTypes } from './actionTypes/app';
import 'moment/locale/uk';
import 'moment/locale/ru';
import 'moment/locale/en-gb';
import { SnackNotification } from '@types';

export const setNotification = (payload: SnackNotification) => {
  return {
    type: appActionTypes.SET_NOTIFICATION,
    payload,
  };
};

export const registerRoute = (payload: string) => {
  return {
    type: appActionTypes.REGISTER_ROUTE,
    payload: payload,
  };
};
